// --- Sanitizer: trim, strip control chars & tags, collapse whitespace
export function sanitizeInput(raw: string): string {
  if (!raw) return '';
  let s = raw.trim();

  // Remove ASCII control chars (except \n \r \t), and DEL
  s = s.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '');

  // Strip any HTML tags (basic)
  s = s.replace(/<[^>]*>/g, '');

  // Collapse internal whitespace
  s = s.replace(/\s+/g, ' ');

  return s;
}
